module.exports = __webpack_public_path__ + "static/img/6323_phase_function_Paper_PointsHejduk_Prediction.4223edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6323_phase_function_Paper_PointsHejduk_Prediction.png
// module id = PlFS
// module chunks = 0